import { db } from "./firebaseConfig";
//import { collection, addDoc } from "firebase/firestore";

import { writeBatch, doc } from "firebase/firestore";
// Get a new write batch

const crearProducto = async ({
  nombre,
  cant,
  cantMin,
  presentacion,
  cantXUnidad,
  idOrigen,
  codigo,
  stockRestanteUnidades,
  stockRestanteTotal,
  precioBase,
  precioCliente,
  precioCorralon,
  precioFerreteria,
}) => {
  const batch = writeBatch(db);
  // agregar un producto nuevo
  const nycRef = doc(db, "productos", crypto.randomUUID());
  batch.set(nycRef, {
    nombre: nombre,
    cant: cant,
    cantMin: cantMin,
    presentacion: presentacion,
    cantXUnidad: cantXUnidad,
    idOrigen: idOrigen,
    codigo: codigo,
    estado: "activo",
    precioBase: precioBase,
    precioCliente: precioCliente,
    precioCorralon: precioCorralon,
    precioFerreteria: precioFerreteria,
  });

  //Actualizar stock Almacen
  const sfRef = doc(db, "stock", idOrigen);
  batch.update(sfRef, {
    cant: stockRestanteUnidades,
    cantTotalxUnidad: stockRestanteTotal,
  });

  return await batch.commit();
};

export default crearProducto;
